/* eslint-disable react/prop-types */
import React from 'react';

import Typography from '@mui/material/Typography';

import { HeaderInfoStyled } from './PayablesDropDown.styles';

const PayablesDropDown = ({ headerInfo }) => (
  <div style={{ width: '288px' }}>
    <HeaderInfoStyled>
      <Typography variant="body2">Total estimado inicial:</Typography>
      <Typography variant="body2" className="value">
        {new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(headerInfo.total_budget || 0)}
      </Typography>
    </HeaderInfoStyled>
    <HeaderInfoStyled>
      <Typography variant="body2">Total estimado inicial por M²:</Typography>
      <Typography variant="body2" className="value">
        {new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(headerInfo.total_budget_per_m2 || 0)}
      </Typography>
    </HeaderInfoStyled>
    <HeaderInfoStyled>
      <Typography variant="body2">Total executado:</Typography>
      <Typography variant="body2" className="value">
        {new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(headerInfo.total_paid || 0)}
      </Typography>
    </HeaderInfoStyled>
    <HeaderInfoStyled>
      <Typography variant="body2">Total executado por M²:</Typography>
      <Typography variant="body2" className="value">
        {new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(headerInfo.total_paid_per_m2 || 0)}
      </Typography>
    </HeaderInfoStyled>
    <HeaderInfoStyled>
      <Typography variant="body2">Total estimado final:</Typography>
      <Typography variant="body2" className="value">
        {new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(headerInfo.total_estimate || 0)}
      </Typography>
    </HeaderInfoStyled>
    <HeaderInfoStyled>
      <Typography variant="body2">Total estimado final por M²:</Typography>
      <Typography variant="body2" className="value">
        {new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(headerInfo.total_estimate_per_m2 || 0)}
      </Typography>
    </HeaderInfoStyled>
  </div>
);

export default PayablesDropDown;
